import { useState, useEffect } from 'react';
import { useCart } from '../../hooks/useCart';
import { getProductImage } from '../../utils/imageStorage';
import Header from '../../components/feature/Header';

export default function ProduitAngeAPoserModele3() {
  const { addItem } = useCart();
  const [quantity, setQuantity] = useState(1);
  const [showNotification, setShowNotification] = useState(false);
  const productId = 'ange-a-poser-modele-3';
  const defaultImage = 'https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/2d5aac0616d1916844df3dca44dc7e88.png';
  const [productImage, setProductImage] = useState<string>(defaultImage);

  const product = {
    id: 'ange-a-poser-modele-3',
    name: 'Ange à poser – 25 cm',
    price: 30,
    stock: 5,
    image: productImage,
    description: 'Petit ange à poser réalisé en livre plié. Élégant, délicat, et fabriqué avec soin.',
    details: {
      fabrication: 'Fait main dans l\'atelier Les Carnets de Lolotte',
      type: 'Pièce artisanale unique',
      dimensions: '25 cm de hauteur',
      delai: '2 à 3 jours',
      materials: 'Pages de livre recyclées, ruban décoratif'
    }
  };

  useEffect(() => {
    const loadImage = async () => {
      const savedImage = await getProductImage(productId);
      if (savedImage) {
        setProductImage(savedImage);
      }
    };
    loadImage();

    const jsonLd = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": product.name,
      "description": product.description,
      "image": product.image,
      "offers": {
        "@type": "Offer",
        "price": product.price,
        "priceCurrency": "EUR",
        "availability": "https://schema.org/InStock"
      }
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    document.title = `${product.name} - Les Carnets de Lolotte`;

    return () => {
      if (document.head.contains(script)) {
        document.head.removeChild(script);
      }
    };
  }, []);

  const handleAddToCart = () => {
    addItem({
      id: product.id,
      name: product.name,
      price: product.price,
      quantity: quantity,
      image: product.image
    });
    setShowNotification(true);
    setTimeout(() => setShowNotification(false), 3000);
  };

  const handleBuyNow = async () => {
    handleAddToCart();
    setTimeout(() => {
      window.REACT_APP_NAVIGATE('/panier');
    }, 500);
  };

  return (
    <>
      <Header />
      <div className="min-h-screen bg-[#F8EDEA]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
            {/* Image */}
            <div className="bg-[#FAF9F8] rounded-2xl p-8 border-2 border-[#B97A72]">
              <img
                src={product.image}
                alt={product.name}
                className="w-full h-auto object-contain rounded-lg"
              />
            </div>

            {/* Informations produit */}
            <div>
              <div className="mb-4">
                <span className="inline-block bg-[#C49B86] text-white px-4 py-1 rounded-full text-sm font-medium">
                  Pièce unique ✨
                </span>
              </div>

              <h1 className="text-4xl font-bold text-[#B97A72] mb-4" style={{ fontFamily: 'Allura, cursive' }}>
                {product.name}
              </h1>

              <p className="text-2xl font-bold text-[#6B5E5A] mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
                {product.price}€
              </p>

              <div className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg p-6 mb-6">
                <p className="text-[#6B5E5A] leading-relaxed" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  {product.description}
                </p>
              </div>

              {/* Caractéristiques */}
              <div className="space-y-3 mb-8">
                <div className="flex items-start">
                  <i className="ri-ruler-line text-[#B97A72] text-xl mr-3 mt-1"></i>
                  <div>
                    <strong className="text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Dimensions :</strong>
                    <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.details.dimensions}</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-leaf-line text-[#B97A72] text-xl mr-3 mt-1"></i>
                  <div>
                    <strong className="text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Matériaux :</strong>
                    <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>{product.details.materials}</span>
                  </div>
                </div>
                <div className="flex items-start">
                  <i className="ri-hand-heart-line text-[#B97A72] text-xl mr-3 mt-1"></i>
                  <div>
                    <strong className="text-[#6B5E5A]" style={{ fontFamily: 'Playfair Display, serif' }}>Fabrication :</strong>
                    <span className="text-[#6B5E5A] ml-2" style={{ fontFamily: 'Poppins, sans-serif' }}>Entièrement fait main</span>
                  </div>
                </div>
              </div>

              {/* Quantité */}
              <div className="mb-6">
                <label className="block text-[#6B5E5A] font-medium mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
                  Quantité
                </label>
                <div className="flex items-center space-x-4">
                  <button
                    onClick={() => setQuantity(Math.max(1, quantity - 1))}
                    className="w-10 h-10 flex items-center justify-center bg-[#FAF9F8] border-2 border-[#B97A72] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-subtract-line"></i>
                  </button>
                  <span className="text-xl font-medium text-[#6B5E5A] w-12 text-center">{quantity}</span>
                  <button
                    onClick={() => setQuantity(Math.min(product.stock, quantity + 1))}
                    className="w-10 h-10 flex items-center justify-center bg-[#FAF9F8] border-2 border-[#B97A72] rounded-full hover:bg-[#B97A72] hover:text-white transition-colors cursor-pointer"
                  >
                    <i className="ri-add-line"></i>
                  </button>
                </div>
                <p className="text-sm text-[#6B5E5A] mt-2" style={{ fontFamily: 'Poppins, sans-serif' }}>
                  Stock disponible : {product.stock}
                </p>
              </div>

              {/* Boutons d'action */}
              <div className="flex flex-col sm:flex-row gap-4 mb-8">
                <button
                  onClick={handleAddToCart}
                  className="flex-1 bg-[#B97A72] text-white px-8 py-4 rounded-full hover:bg-[#C49B86] transition-colors whitespace-nowrap cursor-pointer text-lg font-medium"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  <i className="ri-shopping-cart-line mr-2"></i>
                  Ajouter au panier
                </button>
                <button
                  onClick={handleBuyNow}
                  className="flex-1 bg-[#C49B86] text-white px-8 py-4 rounded-full hover:bg-[#B97A72] transition-colors whitespace-nowrap cursor-pointer text-lg font-medium"
                  style={{ fontFamily: 'Playfair Display, serif' }}
                >
                  Acheter maintenant
                </button>
              </div>

              {/* Informations supplémentaires */}
              <div className="bg-[#EBD2CF] rounded-lg p-4">
                <div className="flex items-center text-[#6B5E5A] mb-2">
                  <i className="ri-truck-line text-[#B97A72] mr-2"></i>
                  <span className="text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>Livraison soignée</span>
                </div>
                <div className="flex items-center text-[#6B5E5A]">
                  <i className="ri-heart-line text-[#B97A72] mr-2"></i>
                  <span className="text-sm" style={{ fontFamily: 'Poppins, sans-serif' }}>Création artisanale unique</span>
                </div>
              </div>
            </div>
          </div>

          {/* Produits similaires */}
          <section className="mt-16">
            <h2 className="text-3xl font-bold text-[#B97A72] mb-8 text-center" style={{ fontFamily: 'Allura, cursive' }}>
              Autres anges de la collection
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              <div onClick={() => window.REACT_APP_NAVIGATE('/produit-ange-joyeux-coeur')} className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer">
                <div className="aspect-square bg-[#F3D9D9]">
                  <img src="https://static.readdy.ai/image/fd456b0d540e8f517714341c204b3126/9ca0f2dee5922ad907a452879600467c.png" alt="Ange Joyeux Cœur" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Ange "Joyeux Cœur"</h3>
                  <p className="text-xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>4€</p>
                </div>
              </div>
              <div onClick={() => window.REACT_APP_NAVIGATE('/produit-ange-reve-doux')} className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer">
                <div className="aspect-square bg-[#F3D9D9]">
                  <img src="https://public.readdy.ai/ai/img_res/5d6e1851-3bb6-4061-970b-fd2625a28c0d.png" alt="Ange Rêve Doux" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Ange "Rêve Doux"</h3>
                  <p className="text-xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>4€</p>
                </div>
              </div>
              <div onClick={() => window.REACT_APP_NAVIGATE('/produit-ange-serenite')} className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer">
                <div className="aspect-square bg-[#F3D9D9]">
                  <img src="https://public.readdy.ai/ai/img_res/744b7b75-1b4f-49c2-a689-d5bb175d844e.png" alt="Ange Sérénité" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Ange "Sérénité"</h3>
                  <p className="text-xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>4€</p>
                </div>
              </div>
              <div onClick={() => window.REACT_APP_NAVIGATE('/produit-ange-a-poser-25cm')} className="bg-[#FAF9F8] border-2 border-[#B97A72] rounded-lg overflow-hidden hover:shadow-xl transition-all cursor-pointer">
                <div className="aspect-square bg-[#F3D9D9]">
                  <img src="https://public.readdy.ai/ai/img_res/7c861076-4330-401d-9c9f-9d520b2e9bf0.png" alt="Ange à poser 25cm" className="w-full h-full object-cover" />
                </div>
                <div className="p-4">
                  <h3 className="text-lg font-semibold text-[#6B5E5A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>Ange à poser – 25 cm</h3>
                  <p className="text-xl font-bold text-[#B97A72]" style={{ fontFamily: 'Playfair Display, serif' }}>20€</p>
                </div>
              </div>
            </div>
          </section>
        </div>

        {/* Notification */}
        {showNotification && (
          <div className="fixed top-20 right-4 z-50 bg-green-500 text-white px-6 py-3 rounded-lg shadow-lg">
            <div className="flex items-center space-x-2">
              <i className="ri-check-line"></i>
              <span style={{ fontFamily: 'Poppins, sans-serif' }}>Produit ajouté au panier !</span>
            </div>
          </div>
        )}
      </div>
    </>
  );
}
